export enum EProfileTabs {
  Personal,
  Extra,
  Tac,
}
